<template>
    <app-framework>
      <header class="container">
        <h1>{{ $t('404_error') }}</h1>
      </header>
      <article class="container framework-slot">
        <p>{{ $t('page_unavailable') }}</p>
        <p>{{ $t('link_broken') }} <router-link to="/">{{ $t('go_to_dashboard_link') }}</router-link>.</p>
      </article>
    </app-framework>
</template>

<script>
    import AppFramework from '@/components/layout/AppFramework'

    export default {
        name: 'not-found',
        i18nOptions: {namespaces: ['not_found', 'common', 'breadcrumbs']},
        components: {AppFramework},
    }
</script>
